module.exports = __webpack_public_path__ + "media/src/images/mails/green_tick-fe4ac4d6897d500db984d3f5bc0eb1d8.png";